import { CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import { navigateToLink } from "../../Utils";

function PublicShortcut() {
  const params = useParams();
  const { shortcut='' } = params;

  navigateToLink(`${process.env.REACT_APP_API_ENDPOINT}/p/${shortcut}`);

  return (
  <div
    style={{
      height: '100vh',
      width: '100vw',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress/>
  </div>);
}

export default PublicShortcut;